import { type MessageDescriptor } from "react-intl";

import { type LensPreviewMediaItem } from "../../shared/state";
import { PreviewValidationErrors } from "../models";

import { messages } from "./messages.generated";

export enum GameLensPreviewValidationError {
    MissingVideo = "missingVideo",
    TooShort = "tooShort",
    DurationOutOfRange = "durationOutOfRange",
}

export interface ValidateGameLensPreviewParams {
    previewMediaItems: readonly LensPreviewMediaItem[];
    previewValidationMessage?: string | null;
}

const validationMessageByError: Record<GameLensPreviewValidationError, MessageDescriptor> = {
    [GameLensPreviewValidationError.MissingVideo]: messages.gameLensPreviewError,
    [GameLensPreviewValidationError.TooShort]: messages.gameLensVideoTooShortError,
    [GameLensPreviewValidationError.DurationOutOfRange]: messages.gameLensVideoDurationOutOfRangeError,
};

export const validateGameLensPreview = ({
    previewMediaItems,
    previewValidationMessage,
}: ValidateGameLensPreviewParams): GameLensPreviewValidationError | null => {
    const previewItem = previewMediaItems[0];

    if (!previewItem?.isVideo && previewValidationMessage === PreviewValidationErrors.GameLensVideoTooShort) {
        return GameLensPreviewValidationError.TooShort;
    }

    if (!previewItem?.isVideo && previewValidationMessage === PreviewValidationErrors.GameLensVideoDurationOutOfRange) {
        return GameLensPreviewValidationError.DurationOutOfRange;
    }

    if (!previewItem?.isVideo) {
        return GameLensPreviewValidationError.MissingVideo;
    }

    return null;
};

export const getGameLensPreviewValidationMessage = (
    validationError: GameLensPreviewValidationError | null,
): MessageDescriptor | undefined => {
    if (!validationError) {
        return undefined;
    }

    return validationMessageByError[validationError];
};
